RivalIQ.module('utils', function (utils, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    utils.BrokenThumbnailHandler = {
        SupportedSources: {
            [RivalIQ.enums.sources.INSTAGRAM_INSIGHTS]: true,
            [RivalIQ.enums.sources.INSTAGRAM]: true,
            [RivalIQ.enums.sources.FACEBOOK_INSIGHTS]: true,
            [RivalIQ.enums.sources.FACEBOOK]: true
        },

        beforeConstruction: function () {
            const me = this;

            me.thumbnailListener = function (e, img) {
                const $img = $(img);
                const $parent = $img.parent();
                const sourceUrl = $img.data('url');
                const htmlType = $img.data('type') || img.tagName?.toLowerCase();

                if (htmlType === 'video' && !$parent.find('video').length) {
                    // if we failed to load the thumbnail, append the original video element and load preview
                    const videoEl = document.createElement('video');
                    videoEl.src = sourceUrl;
                    videoEl.onerror = (e) => {
                        // hide video element if link fails too, we'll default to post text
                        $(e.target).hide();
                        $parent.hide();
                        $parent.parent().find('.text-only').removeClass('display-none');
                    };
                    $parent[0].appendChild(videoEl);
                    videoEl.classList = img.classList;
                    const thumbnailUrl = $img.data('src');
                    utils.BrokenThumbnailHandler.markThumbnailUrlBroken(thumbnailUrl);
                } else if (htmlType === 'img' && !$parent.find('.original-src').length) {
                    const imgEl = document.createElement('img');
                    imgEl.src = sourceUrl;
                    imgEl.classList = img.classList;
                    imgEl.classList.add('original-src');
                    imgEl.onerror = (e) => {
                        // hide video element if link fails too, we'll default to post text
                        $(e.target).hide();
                        $parent.hide();
                        $parent.parent().find('.text-only').removeClass('display-none');
                    };
                    $parent[0].appendChild(imgEl);
                    const thumbnailUrl = $img.data('src');
                    utils.BrokenThumbnailHandler.markThumbnailUrlBroken(thumbnailUrl);
                }

                if ($img[0].tagName.toLowerCase() === 'img') {
                    $img.hide();
                }
            };

            $('body').on('thumbnail.error', me.thumbnailListener);
            me.listenTo(me, 'destroy', me._onDestroy);
        },

        _onDestroy: function () {
            const me = this;
            $('body').off('thumbnail.error', me.thumbnailListener);
        }
    };

    const knownBrokenIgThumbnails = {};
    utils.BrokenThumbnailHandler.isBrokenThumbnailUrl = function (shortcode) {
        return knownBrokenIgThumbnails[shortcode];
    };

    utils.BrokenThumbnailHandler.markThumbnailUrlBroken = function (shortcode) {
        knownBrokenIgThumbnails[shortcode] = true;
    };

}, window.moment);
